<template>
  <div class="locationAdd">
    <h4>Add a Location</h4>
    <div class="location-search">
      <label>Search:</label>
      <GmapAutocomplete @place_changed="setPlace">
      </GmapAutocomplete>
    </div>
    <GmapMap
      ref="locationAddMap"
      :center="{lat: 41.850033, lng: -87.6500523}"
      :zoom="3"
      :options="mapOptions"
      id="ocAddLocationMap"
      class="ocAddLocationMap"
      style="min-height:600px;"
      @click="setLatLng"
      >
      <GmapMarker ref="locationMarker" :position="marker_position" />
    </GmapMap>
    <br />
    <div class="row" v-if="zoom < 10">
      <div class="col-md-6">
        <div class="alert alert-info">
          Please zoom in further to set a location point.
        </div>
      </div>
      <div class="col-md-6">
        <a class="btn" v-on:click="setCurrentLocation"><i class="fa fa-location-arrow fa-2x"></i> Find My Location</a>
        <Loader v-show="getting_location" extraClass="oc-loader-inline" />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
          <label>Location Name:</label>
          <input class="validate-required" type="text" v-model="location.name" placeholder="Location Name" />
          <ErrorField :errors="api_errors" field="name" />
          <label>Location Description:&nbsp;</label><i class="fa fa-info-circle" data-tooltip='Indicate where you were relative to know landmarks, such as towns or intersections.'></i>
          <textarea class="validate-required" type="text" v-model="location.description" placeholder="Location Description" />
          <ErrorField :errors="api_errors" field="description" />
      </div>
      
      <div class="col-md-4">
        <label>Latitude:</label>
        <input class="validate-required" type="text" v-model="location.latitude" placeholder="Latitude" />
        <ErrorField :errors="api_errors" field="latitude" />
        <label>Longitude:</label>
        <input class="validate-required" type="text" v-model="location.longitude" placeholder="longitude" />
        <ErrorField :errors="api_errors" field="longitude" />
      </div>
      <div class="col-md-2">
        <br />
        <div class="input-checkbox">
          <input type="checkbox" name="location_favorite" v-model="location.favorite" />
          <label for="location_favorite"></label>
        </div>
        <span>Add to Favorites</span>
        <br />
        <div class="input-checkbox">
          <input type="checkbox" name="location_private" v-model="location.private_property" />
          <label for="location_private"></label>
        </div>
        <span>Private Property</span>
      </div>
      <div class="col-sm-12">
        <label>&nbsp;</label>
        <button class="btn btn-primary btn-block btn-sm" v-on:click="addLocation">Add Location</button>
      </div>
      <div class="col-md-4 offset-md-8">
        <button class="btn btn-block btn-sm" style="margin-top:5px;" v-on:click="cancelLocation">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationAdd',
  data: function(){
    return {
      location:{
        "name":null,
        "latitude": null,
        "longitude": null
      },
      mapOptions: {
        zoomControl: true,
        mapTypeControl: true,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
      },
      full_lat: null,
      full_lng: null,
      zoom: 3,
      api_errors:{},
      getting_location: false,
      place:null,
    };
  },
  mounted: function(){
    var self = this;
    this.$refs.locationAddMap.$mapPromise.then((map) => {
      this.$refs.locationAddMap.$on('zoom_changed', function(){
        self.zoom = map.getZoom();
      });
    });
  },
  computed:{
      marker_position:{
          get: function(){
              if (this.full_lat == null || this.full_lng == null) {
                return null;
              }
              return {lat: this.full_lat, lng: this.full_lng}
          }
      },
  },
  methods:{
    setCoordinates:function (lat, lng, locationName, obscured){
      this.$refs.locationAddMap.$mapPromise.then((map) => {
        if (!obscured) {
          this.location.latitude = lat.toFixed(7);
          this.full_lat = lat;
          this.location.longitude = lng.toFixed(7);
          this.full_lng = lng;
          this.location.name = locationName;
          this.location.description = "Location from iNaturalist";
        }
        else{
          this.location.description = "Accurate location provided for location obscured iNaturalist sighting.";
        }

        var position = {
          coords:{
            latitude: lat,
            longitude: lng
          }
        }
        this.showPosition(position);
      })
      
    },
    setCurrentLocation: function(){
      this.getting_location = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
      } else {
        this.getting_location = false;
        self.$notify({
          title: 'Geolocation is not supported by this browser.',
          type: 'error',
        });
      }
    },
    showPosition: function(position){
      this.$refs.locationAddMap.$mapPromise.then((map) => {
        map.setZoom(10);
        map.setCenter({lat:position.coords.latitude, lng:position.coords.longitude});
        this.getting_location = false;
      })
    },
    setLatLng: function(event){
      this.$refs.locationAddMap.$mapPromise.then((map) => {
        if (map.getZoom() >= 10) {
          this.full_lat = event.latLng.lat();
          this.full_lng = event.latLng.lng();
          this.location["latitude"] = event.latLng.lat().toFixed(7);
          this.location["longitude"] = event.latLng.lng().toFixed(7);
        }
      })
    },
    cancelLocation: function(){
      this.$emit('locationCanceled');
    },
    addLocation: function(){
      var self = this;
      this.API({
        endpoint: 'locations',
        isPost:true,
        postData: self.location,
        funcThen: function(response){
          self.location = {
            "name":null,
            "latitude": null,
            "longitude": null
          };
          self.$notify({
            title: 'Location Added',
            type: 'success',
          });
          self.$emit('locationAdded', response.data.location)
        },
        funcCatch: function(error){
          self.api_errors = error.response.data;
        },
      });
    },
    setPlace(place) {
      if (place.geometry) {
        this.$refs.locationAddMap.$mapPromise.then((map) => {
          var bounds = new google.maps.LatLngBounds();
          if (place.geometry.viewport) {
            // Only geocodes have viewport.
            bounds.union(place.geometry.viewport);
          } else {
            bounds.extend(place.geometry.location);
          }
          map.fitBounds(bounds);
        });
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/LocationAdd.vue